import { useMemo, useState } from "react";
import { EMPTY_FILTERS } from "./production-workspace-model";
import type { Filters } from "./production-workspace-model";
import type { View } from "./production-report-selection";
import { productionReportPresentation } from "./production-report-presentation";
import { useProductionReportDataWorkspace } from "./useProductionReportDataWorkspace";
import { useProductionReportExportsWorkspace } from "./useProductionReportExportsWorkspace";
import { useProductImages } from "./useProductImages";

export function useProductionReportWorkspace({ dataRefreshVersion, notify }: { dataRefreshVersion: number; notify: (message: string) => void }) {
  const [view, setView] = useState<View>("overview");
  const [recordView, setRecordView] = useState<"records" | "tree">("records");
  const [costOpened, setCostOpened] = useState(false);
  const [filters, setFilters] = useState<Filters>(EMPTY_FILTERS);
  const data = useProductionReportDataWorkspace(dataRefreshVersion);
  const exportActions = useProductionReportExportsWorkspace({ ...data, notify });
  const model = useMemo(() => productionReportPresentation(data.report, filters, data.applied), [data.report, filters, data.applied]);
  const images = useProductImages(model.imageCodes);
  const updateFilter = (key: keyof Filters, value: string) => setFilters(previous => ({ ...previous, [key]: value }));
  const navigateActual = (patch: Partial<Filters>, tree = false) => { setFilters(previous => ({ ...previous, ...patch })); setView("actual"); setRecordView(tree ? "tree" : "records"); };
  return { ...data, ...exportActions, ...model, images, view, setView, recordView, setRecordView, costOpened, setCostOpened, filters, setFilters, updateFilter, navigateActual };
}
